import { useMemo } from 'react'

import type { WeeklySelectionAsRecord, WeeklyValidSelection } from '../../../typings'

export const useSelectionData = (selection?: WeeklyValidSelection) => {
  return useMemo<WeeklySelectionAsRecord | undefined>(() => {
    if (typeof selection === 'number') {
      const result = {} as WeeklySelectionAsRecord
      result[selection] = 1
      return result
    }
    return undefined
  }, [selection])
}
